/* eslint-disable react/jsx-no-bind */
import React from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import Select from 'react-select';
// import { handleRegionSelect, fetchData } from '../../state/actions/createData';

export default function Header() {
  // const curRegion = useSelector((state) => state.data.region);
  // const requestStatus = useSelector((state) => state.data.request);
  // const dispatch = useDispatch();

  /* const refRegion = useRef();

  function handleRegionSelectChange(selected) {
    console.log(selected.value);
    dispatch(handleRegionSelect(selected.value));
    dispatch(fetchData());
  }

  const optionsRegion = [
    {
      id: 'r0',
      value: 'NSW',
      label: 'NSW',
    },
    {
      id: 'r1',
      value: 'VIC',
      label: 'VIC',
    },
    {
      id: 'r2',
      value: 'QLD',
      label: 'QLD',
    },
    {
      id: 'r3',
      value: 'WA',
      label: 'WA',
    },
    {
      id: 'r4',
      value: 'SA',
      label: 'SA',
    },
    {
      id: 'r5',
      value: 'TAS',
      label: 'TAS',
    },
    {
      id: 'r6',
      value: 'NT',
      label: 'NT',
    },
    {
      id: 'r7',
      value: 'ACT',
      label: 'ACT',
    },
  ];

  function getRegionValue() {
    return optionsRegion.find((obj) => {
      return obj.value === curRegion;
    });
  }
  */

  return (
    <header className="mid-col">
      {/*
      <h2>Do you live in a political bubble?</h2>
      <p>
        You may have heard of the &lsquo;Canberra bubble&rsquo; - the idea that
        federal politicians are obsessed with the political argy-bargy around
        Parliemnt house and are not overly concerned with the rest of Australia,
        or even the rest of Canberra.
      </p>

      <p>
        Another kind of filter bubble is the &lsquo;Political bubble&rsquo;,
        when the overwhelming majority vote for the same party. The term is
        generally considered a negative as it implies a potential echo chamber
        of ideas. In a healthy democracy, shouldn&rsquo;t there be a range of
        views and opinions exchanged within society?
      </p>

      <p>
        Based on first preference votes at the last election, are there areas in
        Australia where a party is ubiquitous?
        <br />
        Use the &lsquo;Search Address&rsquo; text box to see how diverse the
        voting was at polling locations within a 5km radius of your residence at
        the 2019 federal election.
      </p>
  */}
      <h4>Search for your address to explore your community</h4>

      {/*
      <Select
        ref={refRegion}
        className="react-select"
        onChange={handleRegionSelectChange}
        options={optionsRegion}
        value={getRegionValue()}
        isDisabled={requestStatus}
        onMenuOpen={() => {
          setTimeout(() => {
            refRegion.current.scrollToFocusedOptionOnUpdate = true;
            refRegion.current.setState({
              focusedOption: optionsRegion.find(
                (option) => option.value === curRegion,
              ),
            });
          }, 0);
        }}
      />
      */}
    </header>
  );
}
